import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetworkSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "network-search" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 15.75,
			cy: 15.75,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 23.25,
			y1: 23.25,
			x2: 19.462,
			y2: 19.462
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,23.25A11.25,11.25,0,1,1,23.25,12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.289,22.921C7.768,20.689,6.75,16.633,6.75,12S7.768,3.312,9.289,1.079"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .775,
			y1: 11.25,
			x2: 9,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.999,
			y1: 5.25,
			x2: 21,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.048,
			y1: 17.25,
			x2: 7.214,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.711,1.079a16.184,16.184,0,0,1,2.2,6.416"
		})
	]
});
export default SvgNetworkSearch;
